/**
*
* WhiteBackground
*
*/

// import React from 'react';
import styled from 'styled-components';

const WhiteBackground = styled.section`

  background:${(props) => props.theme.whiteColor};
  padding:20px;
  h2{
    margin:0px;
    font-size:14px;
  }

`; // eslint-disable-line indent

export default WhiteBackground;



// WEBPACK FOOTER //
// client/components/WhiteBackground/index.js